import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectIsAuthenticated } from '../store/slices/authSlice';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';

// Páginas de autenticación
import { Login, Register } from '../pages/Auth';

// Páginas protegidas
import { Dashboard } from '../pages/Dashboard/Dashboard';
import { InventoryList, AddVehicle, InventoryDetail } from '../pages/Inventory';
import { CreateVehicleTemplate, VehicleTemplateList } from '../pages/VehicleTemplates';
import { NotFound } from '../pages/NotFound/NotFound';

export const AppRoutes: React.FC = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return (
    <Routes>
      {/* Ruta raíz - redirige según autenticación */}
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Rutas públicas (solo accesibles sin autenticación) */}
      <Route
        path="/login"
        element={
          <PublicRoute redirectIfAuthenticated={true}>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute redirectIfAuthenticated={true}>
            <Register />
          </PublicRoute>
        }
      />

      {/* Rutas protegidas (solo accesibles con autenticación) */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/inventory"
        element={
          <PrivateRoute>
            <InventoryList />
          </PrivateRoute>
        }
      />
      <Route
        path="/inventory/add"
        element={
          <PrivateRoute>
            <AddVehicle />
          </PrivateRoute>
        }
      />
      <Route
        path="/inventory/:id"
        element={
          <PrivateRoute>
            <InventoryDetail />
          </PrivateRoute>
        }
      />

      {/* Rutas de Templates */}
      <Route
        path="/vehicle-templates"
        element={
          <PrivateRoute>
            <VehicleTemplateList />
          </PrivateRoute>
        }
      />
      <Route
        path="/vehicle-templates/edit/:id"
        element={
          <PrivateRoute>
            <CreateVehicleTemplate />
          </PrivateRoute>
        }
      />
      <Route
        path="/vehicle-templates/create"
        element={
          <PrivateRoute>
            <CreateVehicleTemplate />
          </PrivateRoute>
        }
      />

      {/* Página 404 - accesible públicamente */}
      <Route path="/404" element={<NotFound />} />

      {/* Catch all - redirige a 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

